import {navigateBackHandler} from "../../../../../helpers/mainHelpers";
import {PageHeader} from "@ant-design/pro-layout";
import {FC} from "react";
import "./style.less"


const NewsItemPageHeader: FC = () => {
  return (
    <PageHeader
      className="news-item-page-header"
      title={
        <span className="news-item-page-header__label">Усі новини</span>
      }
      onBack={navigateBackHandler}
    />)
}
export default NewsItemPageHeader
